import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F8F4EC] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-[#FFFDF9] rounded-2xl border border-[rgba(58,42,37,0.08)] shadow-[0_20px_50px_rgba(58,42,37,0.08)] p-10 sm:p-12 text-center">
        <XCircle size={44} className="text-[#9A8D85] mx-auto" strokeWidth={1.5} />
        <h1 className="font-serif-display text-3xl text-[#2B1F1B] mt-6">Checkout cancelled</h1>
        <p className="mt-3 text-sm font-light leading-relaxed text-[#756A64]" data-testid="payment-cancel-message">
          No payment was made. Your bag is saved — you can complete your order whenever you're ready.
        </p>
        <Link
          to="/"
          className="inline-block mt-8 px-8 py-3.5 bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] rounded-full hover:bg-[#55423A] transition-colors duration-300"
          data-testid="back-to-shop-button"
        >
          Back to Shop
        </Link>
      </div>
    </div>
  );
}
